function calculateDiscountPlugin() {
  // kontrola ci som v detaile produktu
  if($('#product-detail-form .p-info-wrapper').length) {
    document.addEventListener('ShoptetVariantAvailable', function () {
        // kontrola či na produkte existuje zľava
        if($('.p-detail-inner .flag-discount .price-save').length) {
          // ak nájdeme aká je % zľava pošleme ju do vypočítania zľavy + nastavíme, že sa jedná o detail
          calculateDiscount($('.p-image-wrapper .flags .flag-discount .price-save'), true);
        }
    });
  }

  // TODO: toto skontrolovať či je potrebné!
  if($('.p-detail-inner .flag-discount .price-save').length) {
    calculateDiscount($('.p-image-wrapper .flags .flag-discount .price-save'), true);
  }
  calculateDiscountListing();
}
// vytvárame funkciu pre listing -> kategórie / súvisiace produkty / homepage
function calculateDiscountListing() {
  // skontrolujem či existuje element pre % zľavu
  if ($('body').find('.product .price-save').length) {
    // ak nájdeme aká je % zľava pošleme ju do vypočítania zľavy + nastavíme, že sa nejedná o detail
    $('body').find('.product .price-save').each(function (e) {
      calculateDiscount($(this), false);
    });
  }
}

// funkcia je univerzálna aj pre výpočet zľavy v detaile produktu aj pre kategórie / súvisiace produkty iné...
function calculateDiscount(pDiscountElement, isDetail = false) {
  const numberRegex = /\d+(\.\d+)?/;
  var convRate;
  var saveMoney;
  var currencySymbol;
  var minusSignDetail = '';
  var minusSignCategory = '-';

  switch(lang) {
  case 'sk':
    convRate = 1;
    saveMoney = 'ušetríte';
    currencySymbol = '&euro;';
    break;
  case 'hu':
    convRate = 390;
    saveMoney = 'leárazás';
    currencySymbol = 'Ft';
    // pre HU verziu potrebujeme minusovy znak
    minusSignDetail = '-';
    break;
  case 'cs':
    convRate = 25;
    saveMoney = 'ušetříte';
    currencySymbol = 'Kč';
    break;
  case 'ro':
    convRate = 5;
    saveMoney = 'economisiți';
    currencySymbol = 'Lei';
    break;
  case 'bg':
    convRate = 1;
    saveMoney = 'ušetríte';
    currencySymbol = '&euro;';
    break;
  case 'hr':
    convRate = 1;
    saveMoney = 'uštedite';
    currencySymbol = '&euro;';
    break;
  case 'sl':
    convRate = 1;
    saveMoney = 'prihranite';
    currencySymbol = '&euro;';
    break;
  case 'uk':
    convRate = 1;
    saveMoney = 'ušetríte';
    currencySymbol = '&euro;';
    break;
  }
  if(isDetail && $('.p-detail-inner #product-detail-form .p-info-wrapper .variant-list').length && pDiscountElement.find('span').length) {
    pDiscountElement = pDiscountElement.find('.parameter-dependent:not(.no-display)');
  }
  // vyberieme text v % a uložíme do premennej pDiscountValue
  var pDiscountValue = pDiscountElement.text();
  if(pDiscountValue) {
    pDiscountValue = pDiscountValue.replace(/ /g, '');
  }
  var pDiscountMatch = pDiscountValue.match(numberRegex);
  if (pDiscountValue.indexOf('%') !== -1 && pDiscountMatch) {
    var pDiscount = parseFloat(pDiscountMatch[0]);

    if(pDiscount || pDiscount === 0) {
      var pElement = null;
      if(isDetail) {
        pElement = pDiscountElement.closest('.p-detail-inner');
      } else {
        pElement = pDiscountElement.closest('.product');
      }
      var pPriceFinal = 0;
      if(isDetail) {
        if(pElement.find('#product-detail-form .p-info-wrapper .variant-list').length ) {
          pPriceFinal = parseFloat(pElement.find('.p-final-price-wrapper .price-final .price-final-holder:visible').text().replace(/ /g, '').match(numberRegex)[0]);
        } else {
          pPriceFinal = parseFloat(pElement.find('[itemprop="price"]').attr('content'));
        } 
      } else {
        pPriceFinal = parseFloat(pElement.find('[data-micro-price]').data('micro-price'));
      }

      var pFlagDiscountElement = pDiscountElement.closest('.flag-discount');
      var pStandardPriceElement = pElement.find('.price-standard span');
      var pStandardPrice = 0;
      if(pStandardPriceElement) {
        if(isDetail && pElement.find('#product-detail-form .p-info-wrapper .variant-list').length && pElement.find('.p-final-price-wrapper .price-standard .parameter-dependent:visible').length) {
          pStandardPrice = parseFloat(pElement.find('.p-final-price-wrapper .price-standard .parameter-dependent:visible').text().replace(/ /g, '').match(numberRegex)[0]);
          // ak je viac variánt ale len 1 je odkrytá a je možné ju kúpiť vtedy je price-save bez parameter-dependent čiže slelektujeme len price-save - výpredaj
        } else if(isDetail && pElement.find('#product-detail-form .p-info-wrapper .variant-list').length && pElement.find('.p-final-price-wrapper .price-save')) {
          pStandardPrice = parseFloat(pStandardPriceElement.text().replace(/ /g, '').match(numberRegex));
        } else {
            pStandardPrice = parseFloat(pStandardPriceElement.text().replace(/ /g, '').match(numberRegex));
        }
      }
      if(pFlagDiscountElement && pPriceFinal) {
        var pDiscountPrice = Math.round((pPriceFinal / (100-pDiscount) * 100) - pPriceFinal);
        if(pStandardPrice > 0) {
          pDiscountPrice = pStandardPrice - pPriceFinal;
        }
  
        var pDiscountPriceCompare = pDiscountPrice / convRate;
        if(pDiscountPriceCompare > pDiscount) {
          if(isDetail) {
            var newContent = saveMoney + ' ' + minusSignDetail + pDiscountPrice + ' ' + currencySymbol;
            if(pElement.find('#product-detail-form .p-info-wrapper .variant-list').length && pElement.find('.p-final-price-wrapper .price-save span').length) {
              var finalDiscountElement = pElement.find('.p-final-price-wrapper .price-save .parameter-dependent:visible').html(newContent);
            } else {
              var finalDiscountElement = pElement.find('.p-final-price-wrapper .price-save').html(newContent);
            }
        } else {
          var newContent = '<span class="price-save">' + minusSignCategory + pDiscountPrice + ' ' + currencySymbol + '</span>';
          var finalDiscountElement = pFlagDiscountElement.html(newContent);
          }
        }
      }
    }
    if (pDiscount === 0 && finalDiscountElement !== undefined) {
      finalDiscountElement.hide();
    }
  } 
  // Kontrola či existuje prvok s triedou 'parameter-dependent', 'empty' a zároveň nemá triedu 'noDisplay'
  var discountHasVisibleEmptyParameter = $('.price-save .parameter-dependent.empty:not(.noDisplay)').length > 0;
    // Pridávame a odoberáme class podľa toho či existuje takýto prvok
    if (discountHasVisibleEmptyParameter) {
      $('.price-save').addClass('empty-discount-bg');
  } else {
      $('.price-save').removeClass('empty-discount-bg');
  }

  // Check if values parseFinalPriceDefaultValue and parseStandardPriceDefaultValue are same - if they are hide the default value
  var finalPriceDefaultValue = $('.p-info-wrapper-content .price-final .price-final-holder.parameter-dependent.default-variant span.nowrap');
  var standardPriceDefaultValue = $('.p-info-wrapper-content .price-standard .parameter-dependent.default-variant');
  var parseFinalPriceDefaultValue = finalPriceDefaultValue.text().replace(/ /g, '').match(numberRegex);
  var parseStandardPriceDefaultValue = standardPriceDefaultValue.text().replace(/ /g, '').match(numberRegex);
  
  if (parseFinalPriceDefaultValue && parseStandardPriceDefaultValue && parseFinalPriceDefaultValue[0] === parseStandardPriceDefaultValue[0]) {
      standardPriceDefaultValue.closest('.price-standard .parameter-dependent.default-variant').hide();
  }

  // The same principe if values are same - hide price-standard
  $('.product .price.price-final').each(function() {
    var finalPriceProductValue = $(this).find('strong').text().replace(/ /g, '').match(numberRegex);
    var standardPriceProductValue = $(this).find('.price-standard span').text().replace(/ /g, '').match(numberRegex);
  
    if (finalPriceProductValue && standardPriceProductValue && finalPriceProductValue[0] === standardPriceProductValue[0]) {
      $(this).find('.price-standard').hide();
    }
  });
}